import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowRight, FaCalendarAlt, FaTag } from 'react-icons/fa';
import { getAllPosts } from '../content/blog';
import './Blog.css';

const formatDate = (date) =>
  new Date(date).toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });

const Blog = () => {
  const posts = getAllPosts();

  return (
    <section className="blog blog-page">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="section-title"
        >
          <h2>Blog</h2>
          <p>
            Notes on cloud platforms, GitOps, identity, and building reliable foundations
          </p>
        </motion.div>

        <div className="blog-grid">
          {posts.map((post, index) => (
            <motion.article
              key={post.slug}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="blog-card"
            >
              <Link to={`/blog/${post.slug}`} className="blog-card-link">
                <div className="blog-cover">
                  {post.cover ? (
                    <img src={post.cover} alt={post.title} />
                  ) : (
                    <div className="blog-cover-fallback" />
                  )}
                </div>
                <div className="blog-card-body">
                  <div className="blog-meta">
                    <span className="blog-date">
                      <FaCalendarAlt />
                      {formatDate(post.date)}
                    </span>
                    {post.tags?.slice(0, 2).map((tag) => (
                      <span key={tag} className="blog-tag">
                        <FaTag />
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                  <span className="blog-read-more">
                    Read more <FaArrowRight />
                  </span>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
